import ToastComponent from '~/components/ui/ToastComponent.vue';
import { useToast } from 'vue-toastification';

let toastId: number | string | undefined;

export function useCartSyncErrorToast() {
  const toast = useToast();

  function dismissCartSyncError() {
    if (toastId === undefined) return;

    toast.dismiss(toastId);
    toastId = undefined;
  }

  function showCartSyncError(retry: () => Promise<boolean>) {
    if (toastId !== undefined) return;

    toastId = toast.error(
      {
        component: ToastComponent,
        props: {
          btnText: 'Повторить',
          text: 'Проверьте соединение и повторите отправку.',
          title: 'Не удалось сохранить корзину',
        },
        listeners: {
          'btn-click': async () => {
            dismissCartSyncError();
            await retry();
          },
        },
      },
      { closeOnClick: false, timeout: false },
    );
  }

  return {
    dismissCartSyncError,
    showCartSyncError,
  };
}
